import React from 'react'
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form';
import $ from 'jquery';
import Titulo from '../comum/Titulo';

import {PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouPagina} from '../../util/filtros';
import ModalConfirmacaoNovoMapaVeiculo from './ModalConfirmacaoNovoMapaVeiculo';
import buscarMapasVeiculos from '../../actions/mapa-veiculo/buscarMapasVeiculos';
import excluirMapaVeiculo from '../../actions/mapa-veiculo/excluirMapaVeiculo';
import MapasVeiculos from './MapasVeiculos';
import adicionarFiltroMapaVeiculo from '../../actions/mapa-veiculo/adicionarFiltroMapaVeiculo';
import {showSuccessMsg} from '../../util/messagesUtil';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-tabela-dados">
    <div className="row cabecalho-desktop">
      <div className="col-lg-5 col-xl-5">Nome</div>
      <div className="col-lg-5 col-xl-5">Estado</div>
      <div className="col-lg-2 col-xl-2">Ações</div>
    </div>
  </div>
);

const ModalConfirmacaoExclusao = ({ excluir, mapa }) => (
  <div className="modal fade" id="modalConfirmacaoExclusaoMapaVeiculo" tabIndex="-1" role="dialog"
       aria-labelledby="modalConfirmacaoExclusaoMapaVeiculo" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Deseja excluir o mapa de veículo  <strong>{mapa.modelo}?</strong></p>
        </div>
        <div className="modal-footer ">
          <button id='cancelar' type="button" className="btn btn-outline-secondary"
                  data-dismiss="modal">Cancelar
          </button>
          <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                  onClick={() => excluir()}>Excluir
          </button>
        </div>
      </div>
    </div>
  </div>);

export class PainelGerenciarMapasVeiculos extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      parametros: {
        nome: '',
        uf: ''
      },
      mapaSelecionado: ''
    };
  }


  componentDidUpdate (prevProps) {
    if (alterouPagina(this.props, prevProps)) {
      this.props.buscarMapasVeiculos(this.props.filtrosMapaVeiculo, this.props.paginaAtual, this.props.registrosPorPagina);
    }
  }

  abrirModalExclusao (modelo) {
    this.setState({ mapaSelecionado: modelo })
    $('#modalConfirmacaoExclusaoMapaVeiculo')
      .modal('show');
  }

  excluir () {
    this.props.excluirMapaVeiculo(this.state.mapaSelecionado.id).then(() => {
        showSuccessMsg('Mapa excluído com sucesso');

        this.props.buscarMapasVeiculos(this.props.filtrosMapaVeiculo, this.props.paginaAtual, this.props.registrosPorPagina);
        $('input[name=modeloVeiculo]').val('');
        this.props.adicionarFiltroMapaVeiculo('');
    })
  }

  limparFomulario () {
    this.props.reset('formCadastroMapaVeiculo');
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
        <div>
          <div className="row internas">
            <Titulo texto="Gerenciar Mapas de Veículos" urlRetorno="/"/>
          </div>
          <MapasVeiculos selecionar={this.abrirModalExclusao.bind(this)} acaoNovoMapa={this.limparFomulario.bind(this)} selecionado />
        </div>
        <ModalConfirmacaoNovoMapaVeiculo/>
        <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} mapa={this.state.mapaSelecionado}/>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    mapasVeiculos: state.mapasVeiculos.mapasVeiculos,
    paginaAtual: state.paginaAtualMapasVeiculos,
    registrosPorPagina: state.registrosPorPaginaMapasVeiculos,
    cidade: state.cidade,
    filtrosMapaVeiculo: state.filtrosMapaVeiculo
  });


export default connect(mapStateToProps, {
  buscarMapasVeiculos, excluirMapaVeiculo, adicionarFiltroMapaVeiculo
})(reduxForm({
  form: 'formCadastroMapaVeiculo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PainelGerenciarMapasVeiculos));
